import React from 'react';
import RestaurantMenuRoundedIcon from '@mui/icons-material/RestaurantMenuRounded';
import HotelRoundedIcon from '@mui/icons-material/HotelRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import InfoPageLayout from './components/InfoPageLayout';
import InfoSection from './components/InfoSection';
import './InfoPage.scss';

const FEATURES = [
    {
        icon: <RestaurantMenuRoundedIcon />,
        title: 'Streamlined food service',
        description: 'Fast ordering, KOT printing, and billing built for busy kitchens.',
    },
    {
        icon: <HotelRoundedIcon />,
        title: 'Room management',
        description: 'Track room bills, guest orders, and hospitality workflows in one place.',
    },
    {
        icon: <AccessTimeRoundedIcon />,
        title: 'Real-time operations',
        description: 'Live order updates and instant visibility across your team.',
    },
    {
        icon: <GroupsRoundedIcon />,
        title: 'Multi-user support',
        description: 'Role-based access for admins, managers, and staff.',
    },
];

const TEAM = [
    { name: 'Avi Chauhan', role: 'Front-end Developer', initial: 'A' },
    { name: 'Naman Kumar', role: 'Product Manager', initial: 'N' },
    { name: 'Ashutosh', role: 'Quality Analyst', initial: 'A' },
];

const About = () => (
    <InfoPageLayout
        eyebrow="Our company"
        title="About Khaata POS"
        subtitle="Simplifying billing for food and room services in hotels and restaurants — so you can focus on great hospitality."
    >
        <div className="about-grid">
            <InfoSection icon={<RestaurantMenuRoundedIcon />} title="Our story">
                <p>
                    Khaata POS was born from the need to simplify and streamline the billing process
                    for hotels and restaurants. Our system combines powerful features with an
                    intuitive interface, making it the perfect solution for businesses of all sizes.
                </p>
                <p>
                    We understand the unique challenges faced by the hospitality industry and have
                    designed our POS system to address these specific needs, from food ordering to
                    room management.
                </p>
            </InfoSection>

            <InfoSection icon={<HotelRoundedIcon />} title="Our vision">
                <p>
                    We envision a future where billing systems are seamless, empowering businesses to
                    focus on delivering exceptional service. Khaata POS is committed to setting the
                    standard for innovation in the hospitality industry.
                </p>
            </InfoSection>
        </div>

        <InfoSection icon={<AccessTimeRoundedIcon />} title="What we offer">
            <div className="about-feature-grid">
                {FEATURES.map((feature) => (
                    <div className="about-feature" key={feature.title}>
                        <span className="about-feature__icon">{feature.icon}</span>
                        <div>
                            <h3 className="about-feature__title">{feature.title}</h3>
                            <p className="about-feature__desc">{feature.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </InfoSection>

        <div className="about-banner">
            <p className="about-banner__text">Empowering hospitality businesses since 2023</p>
        </div>

        <div className="about-section-heading">
            <h2>Meet our team</h2>
            <p>The passionate minds behind Khaata POS.</p>
        </div>

        <div className="about-team">
            {TEAM.map((member) => (
                <article className="about-team__card" key={member.name}>
                    <div className="about-team__avatar">{member.initial}</div>
                    <h3 className="about-team__name">{member.name}</h3>
                    <p className="about-team__role">{member.role}</p>
                </article>
            ))}
        </div>
    </InfoPageLayout>
);

export default About;
